// extracted by mini-css-extract-plugin
export var card = "PlasmicWorkCard-module--card--JzEIk";
export var img__lEXel = "PlasmicWorkCard-module--img__lEXel--vEQRu";
export var __wab_imgSpacer = "PlasmicWorkCard-module--__wab_img-spacer--wHSSP";
export var freeBox__nzVMu = "PlasmicWorkCard-module--freeBox__nzVMu--HMsKe";
export var freeBox__haSw = "PlasmicWorkCard-module--freeBox__haSw--ZITPA";
export var slotTargetTitle = "PlasmicWorkCard-module--slotTargetTitle--VMCt4";
export var freeBox__uLcd4 = "PlasmicWorkCard-module--freeBox__uLcd4--7yjMC";
export var slotTargetHoverText = "PlasmicWorkCard-module--slotTargetHoverText--kXMzo";